<template>
  <!-- 中间宽度(390–1024): 用固定 390 宽的 iframe 加载移动版, iframe 内真实视口=390,
       像素级还原移动端布局(vw/固定px/clientWidth 全部相对 390)。两侧留白露出页面底色。 -->
  <div class="phoneShell">
    <iframe class="phoneIframe" :src="frameSrc" title="mobile"></iframe>
  </div>
</template>

<script setup>
  // 用当前完整 URL(含 query 与 hash 路由)作为 iframe 源: 同源共享 localStorage, 登录/渠道/
  // 邀请码等参数与当前路由都自然带入; iframe 内 window.self!==window.top → 直接渲染 app(不再套壳)。
  const frameSrc = window.location.href;
</script>

<style scoped>
  .phoneShell {
    position: fixed;
    inset: 0;
    /* 盖住底层始终渲染的 App(不透明背景 + iframe), 高于 App 内一切浮层(游戏 z-index 2000 等) */
    z-index: 100000;
    background: var(--pc-page-bg, #e9ecf4);
    display: flex;
    align-items: stretch;
    justify-content: center;
    /* @media 内 px 不被 postcss 转 vw; 但此文件也可能被转, 故关键尺寸放 @media 里写真实 px */
  }

  .phoneIframe {
    height: 100%;
    border: 0;
    background: #fff;
  }

  @media (min-width: 391px) {
    .phoneIframe {
      width: 390px;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06);
    }
  }
</style>
